import { ApolloQueryResult } from 'apollo-client';
import { PasswordSet } from 'components/authentication/password-set';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IResetPasswordUpdateVariables, MutationResponseByType, MutationType } from 'store/sagas/apiService/types';
import { RootAction, State } from 'store/state';
import { authEmailSelector } from 'store/state/app/selectors';
import { inlineMutate } from 'store/state/mutationsResponse/actions';
import { resetPasswordUpdateResponseSelector, verifyEmailVerificationCodeDataSelector } from 'store/state/mutationsResponse/selectors';

interface SetPasswordProps {
  email: string;
  onSetPassword: (data: IResetPasswordUpdateVariables) => void;
  verifyEmailVerificationCodeData: ApolloQueryResult<MutationResponseByType[MutationType.VerifyEmailVerificationCode]>;
  resetPasswordUpdateResponse: ApolloQueryResult<MutationResponseByType[MutationType.ResetPasswordUpdate]>;
}

const SetPasswordBase: React.FC<SetPasswordProps> = (props) => {
  const {
    email,
    onSetPassword,
    resetPasswordUpdateResponse,
    verifyEmailVerificationCodeData,
  } = props;

  return (
    <PasswordSet
      verifyEmailVerificationCodeData={verifyEmailVerificationCodeData}
      isLoading={resetPasswordUpdateResponse ? resetPasswordUpdateResponse.loading : false}
      onSubmit={onSetPassword}
      email={email}
      fullWidth
    />
  );
};

const mapStateToProps = (state: State) => ({
  email: authEmailSelector(state),
  verifyEmailVerificationCodeData: verifyEmailVerificationCodeDataSelector(state),
  resetPasswordUpdateResponse: resetPasswordUpdateResponseSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onSetPassword: (data: IResetPasswordUpdateVariables) => dispatch(inlineMutate(MutationType.ResetPasswordUpdate, data)),
});

export const SetPassword = connect(mapStateToProps, mapDispatchToProps)(SetPasswordBase);
